// PR 45 review · D2 (Card V3): the engagement's country, currency and weekend (EN + AR). Merged into lib/i18n.js translations
// (big-file rule: new strings in their own file).
export const I18N_D2_LOCALE = {
  en: {
    engLocale: {
      country: "Country", countryPick: "Pick the client's country", countrySearch: "Search country…",
      currency: "Currency", currencyPick: "Pick the currency", currencySearch: "Search code or name…",
      other: "Other – type your own", otherLabel: "Your currency (1 to 10 characters, no < or >; kept exactly as typed)",
      otherRequired: "Type the currency (1 to 10 characters).", otherInvalid: "The currency must be 1 to 10 characters, without < or >.",
      weekend: "Weekend days", weekendHint: "The country ticks a suggestion — change it to the client's real weekend.",
      noWeekend: "No weekend days", weekendRequired: "Tick the weekend days (or choose \"No weekend days\").",
      countryRequired: "Pick the client's country.", currencyRequired: "Pick the currency (or type your own under \"Other\").",
      days: { 0: "Mon", 1: "Tue", 2: "Wed", 3: "Thu", 4: "Fri", 5: "Sat", 6: "Sun" },
      relabelConfirm: "Change the currency from {from} to {to}? Amounts are not converted; only the currency shown changes.",
      weekendStaleConfirm: "Change the weekend? Journal entry testing, the fraud risk and analytics scans and the risk-based samples will show \"re-run\" (nothing re-runs by itself).",
      countryWeekendDiffers: "The weekend saved ({saved}) differs from the usual weekend of {country} ({suggested}). Changing the country does not change the weekend.",
      section: "Country, currency and weekend",
      bannerMissing: "This engagement has no {what} saved yet.",
      bannerWeekendRule: "Its weekend is taken from an older rule until you set it.",
      bannerCountry: "country", bannerCurrency: "currency", bannerWeekend: "weekend", bannerAnd: " and ",
      // PR 45 round 2 · R9
      bannerCurrencyConfirm: "Confirm the currency ({cur}): it was set before the currency had to be confirmed — save it once in Engagement Settings.",
      confirmCurrency: "The currency {cur} is correct — confirm it (saved once; amounts are not changed).",
      bannerLink: "Open Engagement Settings",
    },
    errors: {
      ENGAGEMENT_LOCALE_TEAM_ONLY: "Only members of the engagement team can change the country, currency, weekend, public holidays or working hours.",
      ENGAGEMENT_COUNTRY_REQUIRED: "Pick the client's country before creating the engagement.",
      ENGAGEMENT_COUNTRY_INVALID: "Pick the client's country from the list.",
      ENGAGEMENT_CURRENCY_REQUIRED: "Pick the engagement currency (or type your own under \"Other\") before creating the engagement.",
      ENGAGEMENT_CURRENCY_INVALID: "The currency must be 1 to 10 characters, without < or >.",
      ENGAGEMENT_WEEKEND_REQUIRED: "Tick the weekend days of the client (or choose \"No weekend days\") before creating the engagement.",
      ENGAGEMENT_WEEKEND_INVALID: "Weekend days must be 0 (Mon) to 6 (Sun).",
    },
  },
  ar: {
    engLocale: {
      country: "البلد", countryPick: "اختر بلد العميل", countrySearch: "ابحث عن البلد…",
      currency: "العملة", currencyPick: "اختر العملة", currencySearch: "ابحث بالرمز أو الاسم…",
      other: "أخرى – اكتب عملتك", otherLabel: "عملتك (من 1 إلى 10 أحرف، دون < أو >؛ تُحفظ كما كُتبت تمامًا)",
      otherRequired: "اكتب العملة (من 1 إلى 10 أحرف).", otherInvalid: "يجب أن تتكون العملة من 1 إلى 10 أحرف، دون < أو >.",
      weekend: "أيام عطلة نهاية الأسبوع", weekendHint: "يحدّد البلد اقتراحًا — عدّله إلى عطلة العميل الفعلية.",
      noWeekend: "لا توجد أيام عطلة", weekendRequired: "حدّد أيام العطلة (أو اختر \"لا توجد أيام عطلة\").",
      countryRequired: "اختر بلد العميل.", currencyRequired: "اختر العملة (أو اكتب عملتك ضمن \"أخرى\").",
      days: { 0: "الاثنين", 1: "الثلاثاء", 2: "الأربعاء", 3: "الخميس", 4: "الجمعة", 5: "السبت", 6: "الأحد" },
      relabelConfirm: "تغيير العملة من {from} إلى {to}؟ لا يتم تحويل المبالغ؛ يتغير فقط رمز العملة المعروض.",
      weekendStaleConfirm: "تغيير أيام العطلة؟ سيظهر \"أعد التشغيل\" على اختبار قيود اليومية وفحوص مخاطر الاحتيال والتحليلات والعينات القائمة على المخاطر (لا يُعاد تشغيل شيء تلقائيًا).",
      countryWeekendDiffers: "أيام العطلة المحفوظة ({saved}) تختلف عن العطلة المعتادة في {country} ({suggested}). تغيير البلد لا يغيّر أيام العطلة.",
      section: "البلد والعملة وأيام العطلة",
      bannerMissing: "لم يُحفظ {what} لهذا الارتباط بعد.",
      bannerWeekendRule: "تؤخذ أيام العطلة من قاعدة أقدم حتى تحددها.",
      bannerCountry: "البلد", bannerCurrency: "العملة", bannerWeekend: "أيام العطلة", bannerAnd: " و",
      // PR 45 round 2 · R9
      bannerCurrencyConfirm: "أكّد العملة ({cur}): حُددت قبل أن يصبح تأكيد العملة مطلوبًا — احفظها مرة واحدة في إعدادات الارتباط.",
      confirmCurrency: "العملة {cur} صحيحة — أكّدها (تُحفظ مرة واحدة؛ لا تتغير المبالغ).",
      bannerLink: "افتح إعدادات الارتباط",
    },
    // the server's coded 422s (engagement_locale.TEXT, same words)
    errors: {
      ENGAGEMENT_LOCALE_TEAM_ONLY: "لا يغيّر البلد أو العملة أو أيام العطلة أو العطل الرسمية أو ساعات العمل إلا أعضاء فريق الارتباط.",
      ENGAGEMENT_COUNTRY_REQUIRED: "اختر بلد العميل قبل إنشاء الارتباط.",
      ENGAGEMENT_COUNTRY_INVALID: "اختر بلد العميل من القائمة.",
      ENGAGEMENT_CURRENCY_REQUIRED: "اختر عملة الارتباط (أو اكتب عملتك ضمن \"أخرى\") قبل إنشاء الارتباط.",
      ENGAGEMENT_CURRENCY_INVALID: "يجب أن تتكون العملة من 1 إلى 10 أحرف، دون < أو >.",
      ENGAGEMENT_WEEKEND_REQUIRED: "حدّد أيام عطلة نهاية الأسبوع لدى العميل (أو اختر \"لا توجد أيام عطلة\") قبل إنشاء الارتباط.",
      ENGAGEMENT_WEEKEND_INVALID: "يجب أن تكون أيام العطلة من 0 (الاثنين) إلى 6 (الأحد).",
    },
  },
};

export default I18N_D2_LOCALE;
